<template>
  <section class="container-section">
    <div class="sub-container">
      <section class="section-titles">
        <h3 class="title">
          Gastos de Pre-Embarque
        </h3>
      </section>
      <section>
        <div class="list-items">
          <div class="items">
            <label
              v-if="transportMode === 1"
              style="cursor: pointer"
            >
              <input
                v-model="administrationFees.hasBLOrAWLCost"
                class="uk-checkbox"
                type="checkbox"
              > Costos AWS
            </label>
            <label v-else>
              <input
                v-model="administrationFees.hasBLOrAWLCost"
                class="uk-checkbox"
                type="checkbox"
              > Costos B/L o AWL
            </label>
          </div>

          <div
            v-if="aerialOff"
            class="items"
          >
            <label style="cursor: pointer">
              <input
                v-model="administrationFees.customsAgentServices"
                class="uk-checkbox"
                type="checkbox"
              > Servicios Agente de Cargas
            </label>
          </div>

          <div
            v-if="aerialOff"
            class="items"
          >
            <label style="cursor: pointer">
              <input
                v-model="administrationFees.hasFreightForwarderServices"
                class="uk-checkbox"
                type="checkbox"
              > Tramitación de Permiso por Agente Aduanal
            </label>
          </div>

          <div
            v-if="aerialOff"
            class="items"
          >
            <label style="cursor: pointer">
              <input
                v-model="administrationFees.cleaningFee"
                class="uk-checkbox"
                type="checkbox"
                disabled
              > Cleaning Fee
            </label>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { transportModeTypeEnum, directionTypeEnum } from '../../../types'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      directionTypeEnum,
      transportModeTypeEnum,
      aerialOff: null,

      administrationFees: {
        hasBLOrAWLCost: null,
        hasFreightForwarderServices: null,
        customsAgentServices: null,
        cleaningFee: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'administrationFeesStore',
      'transportMode',
      'journeyDirection'
    ])
  },

  watch: {
    administrationFees: {
      handler: function (newVal) {
        this.$store.commit('setAdministrationFees', newVal)
      },
      deep: true
    }
  },
  mounted () {
    this.administrationFees = { ...this.administrationFeesStore }
    this.notApplyAir()
    if (!this.aerialOff) {
      this.administrationFees.cleaningFee = null
      this.$store.commit('setAdministrationFees', this.administrationFees)
    }
  },
  methods: {
    notApplyAir () {
      if (this.transportMode === this.transportModeTypeEnum.aerial && this.journeyDirection === this.directionTypeEnum.export) {
        this.aerialOff = false
      } else {
        this.aerialOff = true
      }
    }
  }
}
</script>

<style scoped>

section{
  padding: 10px;
}
.container-section{
  padding: 10px 40px;
  width: 100%;
}

.sub-container{
  min-height: 450px;
}
.title{
  font-weight: 600;
  margin-bottom: 10px;
}
.uk-checkbox:disabled{
  background: rgb(14, 109, 205);
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2211%22%20viewBox%3D%220%200%2014%2011%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23fff%22%20points%3D%2212%201%205%207.5%202%205%201%205.5%205%2010%2013%201.5%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  background-repeat: no-repeat ;
  background-position: 4px 0px 0px 1px;
  border: 1px solid rgb(14, 109, 205) ;
}

.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}
.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);

}

.items{
  margin-bottom: 30px ;
}

@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
    padding: 0px;
  }
  .container-section{
    padding: 10px 20px;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }
.opt{
    font-size: 10px;
  }

}
</style>
